import { Component, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';

declare var $ : any;
var image1 = new Image();
var image2 = new Image();
var image3 = new Image();
var image4 = new Image();
var image5 = new Image();
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  config: SwiperOptions = {
    pagination: { 
      el: '.swiper-pagination', 
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 15,
    slidesPerView: 4,
    speed: 1000,
    loop: true,
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      0: {
          slidesPerView: 1,
      },
      640: {
          slidesPerView: 2,
          spaceBetween: 15,
      },
      768: {
          slidesPerView: 3,
          spaceBetween: 15,
      },
      1024: {
          slidesPerView: 4,
          spaceBetween: 15,
      },
    }, a11y: {
      containerMessage: 'Client Testimonials',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    },
  };  

  typed_options = {
    strings: ['Billing.','Appointments.','Prescriptions.','Diagnostic Reports.','Inventory.','Claim Settlement.','Occupancy.','Compliances.'],
    typeSpeed: 70,
    loop: true,
    loopCount: Infinity,
    backSpeed: 35,
    backDelay: 1000
  };

  client_logos:any = [];
  usps:any = [];
  testimonials : any = [];

  // Hospital state to control what image is shown in 3d
  hospital_state: any = 'static-2';
  constructor() {
   
    this.usps = [{
      header: 'Digitize records in seconds',
      sub_header: 'Transform any document to digital',
      button: 'Click to Switch',
      img: 'assets/img/digitize.svg',
      alt: 'Doctor looking at data'
    }, {
        header: 'Customize as per your needs',
        sub_header: 'Built to fit your custom requirements.',
        button: 'Make it Yours',
        img: 'assets/img/customize.svg',
        alt: 'Doctor utilizing digital buttons and files'
    }, {
        header: 'Access from anywhere at any time',
        sub_header: 'Stay connected 24/7 with access from any device',
        button: 'Get Access',
        img: 'assets/img/access.svg',
        alt: 'People accessing their devices'
    }, {
        header: 'Risk-free data security',
        sub_header: 'Secure your data and eliminate the risk of data loss',
        button: 'Shield Now',
        img: 'assets/img/security.svg',
        alt: 'Person using a secure software'
    }, {
        header: 'Expert support just a call away',
        sub_header: 'Dedicated account manager for fast resolution',
        button: 'Consult Now',
        img: 'assets/img/expert_support.svg',
        alt: 'Customer support executive'
    }, {
        header: 'Pay your way, hassle-free',
        sub_header: 'Flexible payment plan that suits you best',
        button: 'Plan Now',
        img: 'assets/img/payment.svg',
        alt: 'Person utilizing payment methods'
    }, {
        header: 'Training as per your needs ',
        sub_header: 'Personalized software training for you and your team',
        button: 'Get Training',
        img: 'assets/img/Training.svg',
        alt: 'Person conducting expert training sessions'
    }, {
        header: 'Unmatched quality service at your door step',
        sub_header: 'Experience the difference with us',
        button: 'Experience Now',
        img: 'assets/img/service.svg',
        alt: 'Person using digital products'
    }];

    this.testimonials = [
      {
        id: 1,
        rating: 5,
        quote: 'Amazing Hospital management software to use, we\'ve been able to reduce wait times and improve patient satisfaction since implementing this software.',
        user: 'Sandeep Bhardwaj',
        designation: 'Admin',
        hospital: 'Vikas Hospital Pvt. Ltd.'
      }, {
        id: 2,
        rating: 5,
        quote: 'The interface is user-friendly and the customer support team is always available to assist us. Highly recommend!',
        user: 'Dr. VS Chauhan',
        designation: 'Director',
        hospital: 'Prakash Hospital GN'
      }, {
        id: 3,
        rating: 5,
        quote: 'It has helped us streamline our billing and inventory management process. The reports generated by the system have also been incredibly useful in analyzing our operations and making data-driven decisions.',
        user: 'Mr. Amit Jain',
        designation: 'Director',
        hospital: 'Surya Kiran Hospital'
      }, {
        id: 4,
        rating: 5,
        quote: 'We can easily manage patient appointments and avoid double booking. The system also sends automated reminders.',
        user: 'Apoorva Sharma',
        designation: 'Senior Consultant',
        hospital: 'Endodontist'
      } , {
        id: 5,
        rating: 5,
        quote: 'The interface is user-friendly and the customer support team is always available to assist us. Highly recommend!',
        user: 'Dr. Gurmeet Yadav',
        designation: 'Director',
        hospital: 'Sona Hospital - Bulanshahr'
      } , {
        id: 6,
        rating: 5,
        quote: 'Thanks to NUVERTOS operating system, whose cloud solutions are better and less expensive than ever before. With this technology, we have a tremendous opportunity to improve access to healthcare for everyone.',
        user: 'Dr. Abhinav Agarwal',
        designation: 'Director',
        hospital: 'Sudhir Nursing Home'
      } , {
        id: 7,
        rating: 5,
        quote: 'Most simplified hospital software in the market. We upgraded to the software almost a year and half back and our daily operational challenges have sorted . The custom developement and prompt service query response has helped us to implement the software among staff easily.',
        user: 'Dr. Geetanshu',
        designation: 'Director',
        hospital: 'Mamta Hospital'
      } , {
        id: 8,
        rating: 5,
        quote: 'Its has been 5 years using this software. We have upgraded our hospital functioning with time and the Nuvertos hospital software has helped us improve our patient experience. The system is tailor made as per your requirement and easy to use.',
        user: 'Manoj Nagar',
        designation: 'Admin',
        hospital: 'Nagar Hospital Ghaziabad'
      } , {
        id: 9,
        rating: 5,
        quote: 'After trying multiple software we finalized to try Nuvertos software. We would recommend this software to all as our entire hospital and all department is now paperless. Best hospital software.',
        user: 'Dr. Shalini Mohan',
        designation: 'Director',
        hospital: 'Orthocare Hospital & Trauma Centre'
      } , {
        id: 10,
        rating: 5,
        quote: 'We have been associated with the system and very happy with the overall service. The updates are regular and helps us to keep us with compliance.',
        user: 'Dr. N. Harisinghani',
        designation: 'Medical Superintendent',
        hospital: 'SMS Hospital'
      } , {
        id: 11,
        rating: 5,
        quote: 'We recently updated our system to Nuvertos and we are very satisfied with the overall experience. The software is customizable as per your requirement and the service repose is quick. Would recommend the same to all.',
        user: 'Dr. Ankit Gupta',
        designation: 'Director',
        hospital: 'SRG Speciality Hospital'
      } , {
        id: 12,
        rating: 5,
        quote: 'Best service and training provided by Nuvertos. Our staff learned the software easily and have been using the system regularly.',
        user: 'Dr. Mursaleen Panwar',
        designation: 'Director',
        hospital: 'Meerut Life Line Hospital'
      } , {
        id: 13,
        rating: 5,
        quote: 'Best hospital software. Easy to use and customizable. The service team responds to issues very fast and solve them.',
        user: 'Dr. Saba Khan',
        designation: 'Admin',
        hospital: 'JR Hospital'
      } , {
        id: 14,
        rating: 5,
        quote: 'Best hospital software in most affordable prices . Would definitely recommend this all hospitals looking for streamlining there operations.',
        user: 'Dr. Gagan Arora',
        designation: 'Admin',
        hospital: 'C. M. Patel Hospital'
      } , {
        id: 15,
        rating: 5,
        quote: 'We have implemented this software in our hospital and it has been a year now. We are very satisfied with service and would recommend this to all',
        user: 'Mr. Vikas Chaudhary',
        designation: 'Admin',
        hospital: 'Meerut Life Line Hospital'
      } , {
        id: 16,
        rating: 5,
        quote: 'Affordable and easy to use Software would recommended this to all Hospital',
        user: 'Dr. Gita Gupta',
        designation: 'Admin',
        hospital: 'Dr. Gupta Nursing Home'
      }
    ]
   }

  ngOnInit() {
    image1.src = 'assets/img/3d/3d_hospital.webp';
    image2.src = 'assets/img/3d/3d_clinic.webp';
    image3.src = 'assets/img/3d/3d_lab.webp';
    image4.src = 'assets/img/3d/3d_pharmacy.webp';
    image5.src = 'assets/img/3d/3d_radio.webp';

  }

  openDemo(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Demo Request');
  }

  openContact(){
    $('#free-demo').modal('show');
    $('#enquiry-header').text('Contact Us');
  }

  enableHospitalState(state){
    console.log(state);
    this.hospital_state = state.panelId
  }
}
